module.exports = __webpack_public_path__ + "static/media/SourceSans-Light.af2998d6.woff";